import React from "react";

// Editorial monogram tile used in place of stock portraits for representative
// example testimonials. Renders a large serif monogram over a subtly
// architectural noise field.
export const MonogramTile = ({ initials = "SP", accent = "#C4A47C", className = "" }) => (
  <div
    className={`relative w-full h-full flex items-center justify-center overflow-hidden ${className}`}
    style={{ background: "#EDE6D6" }}
    aria-hidden="true"
  >
    {/* Diagonal hairline grid */}
    <svg
      className="absolute inset-0 w-full h-full opacity-[0.45]"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      viewBox="0 0 200 240"
    >
      {Array.from({ length: 24 }).map((_, i) => (
        <line
          key={i}
          x1={-40 + i * 12}
          y1="0"
          x2={20 + i * 12}
          y2="240"
          stroke={accent}
          strokeWidth="0.5"
        />
      ))}
    </svg>

    {/* Corner registration marks */}
    <div
      className="absolute top-4 left-4 font-mono text-[10px] tracking-[0.28em] uppercase"
      style={{ color: "#8A6A38" }}
    >
      SPF
    </div>
    <div className="absolute bottom-4 right-4 font-mono text-[10px] tracking-[0.28em] uppercase text-[#5A5548]/60">
      ● Representative
    </div>

    {/* Monogram */}
    <div
      className="font-serif italic leading-none"
      style={{
        fontSize: "clamp(96px, 18vw, 190px)",
        color: "#1a1815",
        letterSpacing: "-0.04em",
      }}
    >
      {initials}
    </div>
  </div>
);

export default MonogramTile;
